/**
 * BOS — Subscription Confirmed
 *
 * Static confirmation page linked from the Brevo double-opt-in redirect
 * (BREVO_DOI_REDIRECT_URL). Renders no API calls — Brevo owns the
 * confirmation state entirely.
 */

import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { FadeUp } from "../components/Reveal";

export default function SubscriptionConfirmed() {
  return (
    <main data-testid="subscription-confirmed-page">
      <PageHeader
        overline="The Operational Brief"
        titleLines={["Your subscription", "is confirmed."]}
        lede="You are now subscribed to The Operational Brief. You will receive one considered edition each month, with occasional relevant BOS research and resources."
      />

      <section className="bg-paper border-t border-rule">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <FadeUp>
            <div className="flex flex-col items-start gap-6">
              <Link
                to="/insights"
                data-testid="subscription-confirmed-primary-cta"
                className="inline-flex items-center gap-2 bg-terra text-white text-[12px] font-semibold uppercase tracking-[0.12em] px-6 py-3.5 hover:bg-ink transition-colors duration-300"
              >
                Read the latest insights <ArrowUpRight size={15} />
              </Link>
              <Link
                to="/"
                data-testid="subscription-confirmed-secondary-link"
                className="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.14em] text-terra link-rule"
              >
                Return to BOS
              </Link>
            </div>
          </FadeUp>
        </div>
      </section>
    </main>
  );
}
